import * as validators from '@brazilian-utils/brazilian-utils'

export abstract class ValidatorHelper {
  static isCpf(value?: string) {
    return validators.isValidCPF(value ?? '')
  }

  static isCnpj(value?: string) {
    return validators.isValidCNPJ(value ?? '')
  }
}
